module.exports = __webpack_public_path__ + "img/Shandong-speed.6ef46133.png";